export default __webpack_public_path__ + "static/media/background-large-yellow.846b0232.png";